module.exports = __webpack_public_path__ + "img/优酷logo.944bbf6e.png";